import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { isEmpty, filter } from 'lodash'
import Fuse from 'fuse.js'

import Layout from 'containers/Layout'
import Printers from 'containers/Printers'
import useDataRefresh from 'hooks/useDataRefresh'

import { fetchPrinters } from 'store/Printers/actions'
import { fetchConfigurations } from 'store/Configurations/actions'
import { setConfiguredPrintersVisible } from 'store/AppState/actions'
import { getPrinterFilters } from 'store/Printers/selector'
import { getCurrentVenueId } from 'store/Venues/selector'
import { getPrintersWithAssociatedConfiguration } from 'store/Configurations/selector'
import { getIsConfiguredPrintersVisible } from 'store/AppState/selector'
import paginationCoordinator from 'utils/paginationCoordinator'

const FUSE_OPTIONS = {
  threshold: 0.2,
  location: 0,
  distance: 100,
  maxPatternLength: 32,
  minMatchCharLength: 1,
  keys: ['name', 'uuid', 'printerType', 'connection'],
}
const FILTER_CONSTRAINTS = (item) => {
  return item.printerType && item.connection
}

export const PrintersIndex = (props) => {
  const history = useHistory()
  const {
    fetchPrinters,
    fetchConfigurations,
    printers,
    currentVenueId,
    searchQuery,
    setConfiguredPrintersVisible,
    isConfiguredPrintersVisible,
  } = props

  const fetchData = () => {
    if (isEmpty(currentVenueId)) {
      return Promise.resolve()
    } else {
      return Promise.all([fetchPrinters(currentVenueId), fetchConfigurations(currentVenueId)])
    }
  }
  const [isLoadingPrinters] = useDataRefresh(fetchData, [currentVenueId])
  const preFilteredDevices = isConfiguredPrintersVisible
    ? filter(printers, FILTER_CONSTRAINTS)
    : printers
  const renderedDevices = isEmpty(searchQuery)
    ? preFilteredDevices
    : new Fuse(preFilteredDevices, FUSE_OPTIONS).search(searchQuery)

  const paginator = paginationCoordinator(renderedDevices, history)

  return (
    <Layout
      checkboxLabel="Show configured Printers"
      handleSwitch={setConfiguredPrintersVisible}
      isSidebar={true}
      isSwitchChecked={isConfiguredPrintersVisible}
      title="Printers"
    >
      <Printers
        isFilteringItems={!isEmpty(searchQuery)}
        isLoadingDevices={isLoadingPrinters}
        paginator={paginator}
      />
    </Layout>
  )
}

PrintersIndex.propTypes = {
  fetchPrinters: PropTypes.func.isRequired,
  fetchConfigurations: PropTypes.func.isRequired,
  printers: PropTypes.array.isRequired,
  currentVenueId: PropTypes.string,
  searchQuery: PropTypes.string.isRequired,
  setConfiguredPrintersVisible: PropTypes.func.isRequired,
  isConfiguredPrintersVisible: PropTypes.bool.isRequired,
}

const mapStateToProps = (state) => ({
  isConfiguredPrintersVisible: getIsConfiguredPrintersVisible(state),
  printers: getPrintersWithAssociatedConfiguration(state),
  currentVenueId: getCurrentVenueId(state),
  searchQuery: getPrinterFilters(state, 'searchQuery'),
})

const mapDispatchToProps = {
  fetchPrinters,
  fetchConfigurations,
  setConfiguredPrintersVisible,
}

export default connect(mapStateToProps, mapDispatchToProps)(PrintersIndex)
